import * as React from 'react'
import { Link } from 'react-router'
import { styles } from './styles.css'

type Props = {
  title: string
  subtitle?: string
  href: string
  disabled?: boolean
}

export const SubscribeButton: React.FC<Props> = ({ title, subtitle, href, disabled }) => {
  return (
    <Link to={disabled ? null : href} className={styles.button} aria-disabled={disabled} tabIndex={disabled ? -1 : 0} reloadDocument>
      <p className={styles.title}>{title}</p>
      <span className={styles.subtitle}>{subtitle}</span>
    </Link>
  )
}
